import Tree from './Tree';
import TreeNode from './TreeNode';

Tree.TreeNode = TreeNode;

export { TreeNode };
export default Tree;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-tree@1.14.4@rc-tree/es/index.js
// module id = null
// module chunks = 